import React, { useState } from "react";
import { Navbar } from "../../components/Navbar";
import { Sidebar } from "../../components/Sidebar";
import { FaImage, FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
export default () => {
  let initialState = {
    account_holder_name: "",
    w9_document: "",
    company_name: "",
    address: "",
    routing_number: "",
    bank_acount_number: "",
    ssn_ein: "",
  };
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSort = () => {
    // Flip sort order
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    // Then, implement your sorting logic here or in a useEffect hook
  };
  const [payement, setPayment] = useState(initialState);
  const handleChange = (key, value) => {
    setPayment({ ...payement, [key]: value });
  };
  const { request, loading, error } = useApi((formData) =>
    apiClient.post("/installerPayment", formData)
  );
  useEffect(() => {
    const fetch = async () => {
      const response = await apiClient.get("/installerPayment");
      const data = response?.data;
      setPayment(data);
    };
    fetch();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("account_holder_name", payement.account_holder_name);
    formData.append("address", payement.address);
    formData.append("company_name", payement.company_name);
    formData.append("routing_number", payement.routing_number);
    formData.append("ssn_ein", payement.ssn_ein);
    formData.append("w9_document", payement.w9_document);
    formData.append("bank_acount_number", payement.bank_acount_number);
    const result = await request(formData);
    // const result = await apiClient.post("/vehiclePayment", formData);
    if (!result.ok) return toast.error("Error");
    toast.success("Account Succesfully Created");
  };
  return (
    <div>
      <div className="site-content h-100">
        <div className="p-4">
          <div className="site-content-body">
            {/*-----------------------------
                  Start || Payment section
              ----------------------------- */}
            <section className="payment-sec main-sec py-3">
              <div className="container">
                <form onSubmit={handleSubmit}>
                  <div className="row justify-content-between">
                    <div className="col-md-6 pe-md-2 pe-lg-3 pe-xl-5">
                      <div className="input-main my-3">
                        <label
                          htmlFor="holder-name"
                          className="d-block blue-txt"
                        >
                          Account Holder Name
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="text"
                          value={payement?.account_holder_name}
                          id="holder-name"
                          onChange={(e) =>
                            handleChange("account_holder_name", e.target.value)
                          }
                        />
                      </div>
                      <div className="input-main my-3">
                        <label
                          htmlFor="company-name"
                          className="d-block blue-txt"
                        >
                          Company Name
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="text"
                          id="company-name"
                          value={payement?.company_name}
                          onChange={(e) =>
                            handleChange("company_name", e.target.value)
                          }
                        />
                      </div>
                      <div className="input-main my-3">
                        <label
                          htmlFor="routing-nmbr"
                          className="d-block blue-txt"
                        >
                          Routing Number
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="number"
                          id="routing-nmbr"
                          value={payement?.routing_number}
                          onChange={(e) =>
                            handleChange("routing_number", e.target.value)
                          }
                        />
                      </div>
                      <div className="input-main my-3">
                        <label htmlFor="acc-nmbr" className="d-block blue-txt">
                          Bank Account Number
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="number"
                          id="acc-nmbr"
                          value={payement?.bank_acount_number}
                          onChange={(e) =>
                            handleChange("bank_acount_number", e.target.value)
                          }
                        />
                      </div>
                      <div className="input-main my-3">
                        <label htmlFor="acc-nmbr" className="d-block blue-txt">
                          SSN or EIN
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="text"
                          id="acc-nmbr"
                          value={payement?.ssn_ein}
                          onChange={(e) =>
                            handleChange("ssn_ein", e.target.value)
                          }
                        />
                      </div>
                      <div className="input-main my-3">
                        <label htmlFor="acc-nmbr" className="d-block blue-txt">
                          Address
                        </label>
                        <input
                          className="d-block rounded-3 py-2 px-3 w-100 mt-1"
                          type="text"
                          id="acc-nmbr"
                          value={payement?.address}
                          onChange={(e) =>
                            handleChange("address", e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0 ps-md-2 ps-lg-3 ps-xl-5">
                      <div className="input-main my-3">
                        <label
                          htmlFor="upload-doc"
                          className="d-block blue-txt"
                        >
                          W9 Document Upload
                        </label>
                        <div className="upload mt-1 py-2 px-3  rounded-3">
                          <label
                            htmlFor="upload-doc"
                            className="d-flex justify-content-center"
                          >
                            {/* <i className="fa-solid fa-image" /> */}
                            <FaImage />
                            <input
                              className="py-2 px-3 d-none"
                              type="file"
                              id="upload-doc"
                              onChange={(e) =>
                                handleChange("w9_document", e.target.files[0])
                              }
                            />
                          </label>
                        </div>
                        <img
                          className="img-fluid w-25"
                          src={payement?.w9_document}
                          alt=""
                        />
                      </div>
                      {/* ---------Invoices TABLE------- */}
                      <div className="input-main my-2">
                        <label className="blue-txt">
                          Invoices &amp; Invoice Status
                        </label>
                        <div className="invoices table-responsive mt-1">
                          <table className="table">
                            <thead>
                              <tr>
                                <th onClick={handleSort}>
                                  Date
                                  <span className="ml-2">
                                    {sortOrder == "asc" ? (
                                      <i className="bi bi-caret-up-fill" />
                                    ) : (
                                      <i className="bi bi-caret-down-fill" />
                                    )}
                                  </span>
                                </th>
                                <th>
                                  Invoice #
                                  <span className="ml-2">
                                    <i className="bi bi-caret-up-fill" />
                                  </span>
                                </th>
                                <th>
                                  Amount
                                  <span className="ml-2">
                                    <i className="bi bi-caret-up-fill" />
                                  </span>
                                </th>
                                <th>
                                  Status
                                  <span className="ml-2">
                                    <i className="bi bi-caret-up-fill" />
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Paid</span>
                                    <i className="bi bi-circle-fill text-success" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Unpaid</span>
                                    <i className="bi bi-circle-fill text-danger" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Pending</span>
                                    <i className="bi bi-circle-fill text-warning " />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Unpaid</span>
                                    <i className="bi bi-circle-fill text-danger" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Paid</span>
                                    <i className="bi bi-circle-fill text-success" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Unpaid</span>
                                    <i className="bi bi-circle-fill text-danger" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Pending</span>
                                    <i className="bi bi-circle-fill text-warning " />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Unpaid</span>
                                    <i className="bi bi-circle-fill text-danger" />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <span>Paid</span>
                                    <i className="bi bi-circle-fill text-success" />
                                  </div>
                                </td>
                              </tr>
                              <tr className="link">
                                <td colSpan={4} className="text-center">
                                  <a href="#">Load more....</a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center">

                  <button className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0">
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>
                  </div>
                </form>
              </div>
            </section>
            {/*-----------------------------
                          End || Payment section
                      ----------------------------- */}
          </div>
        </div>
      </div>
    </div>
  );
};
